import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { usersListAll } from "@/api/user";
import { Message } from "element-ui";
import { getSonRole } from "@/api/auth/onlineUser";
import { mapActions, mapState } from "vuex";
export default {
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      optionsoRganization: [],
      allList: [],
      id: "",
      form: {
        email: "",
        password: "",
        nickname: "",
        auth_group_id: "",
        id: "",
        status: "1"
      },
      rules: {
        email: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }],
        nickname: [{
          required: true,
          message: "请输入昵称",
          trigger: "blur"
        }],
        auth_group_id: [{
          required: true,
          message: "请选择角色",
          trigger: "change"
        }],
        status: [{
          required: true,
          message: "请选择用户状态",
          trigger: "change"
        }]
      },
      formLabelWidth: "80px"
    };
  },
  computed: _objectSpread({
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  }, mapState({
    userInfo: function userInfo(state) {
      return state.d2admin.user.info;
    }
  })),
  created: function created() {},
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/user", ["queryUsers", "queryupUser", "upUser", "userAdd"])), {}, {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query, queryupUser;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                _this.id = id;
                _context.next = 4;
                return getSonRole({
                  page: 1,
                  page_size: 10000
                });

              case 4:
                query = _context.sent;
                _this.optionsoRganization = query.data.data;

                if (!(id != "t")) {
                  _context.next = 15;
                  break;
                }

                _context.next = 9;
                return _this.queryupUser({
                  id: id
                });

              case 9:
                queryupUser = _context.sent;
                _this.form.email = queryupUser.admin_info.email;
                _this.form.nickname = queryupUser.admin_info.nickname;
                _this.form.status = String(queryupUser.admin_info.status);
                _this.form.auth_group_id = queryupUser.admin_info.auth_group_id;
                _this.form.id = id;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataReset: function dataReset() {
      this.form.email = "";
      this.form.nickname = "";
      this.form.auth_group_id = "";
      this.form.id = "";
      this.form.status = "1";
      this.form.password = "";
      this.dialogFormVisible = false;
    },
    resetForm: function resetForm(formName) {
      this.dataReset();
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var query, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = _objectSpread(_objectSpread({}, _this2.form), {}, {
                  parent_id: _this2.userInfo.id
                });

                if (!(_this2.id != "t")) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return _this2.upUser(data);

              case 4:
                query = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.next = 9;
                return _this2.userAdd(data);

              case 9:
                query = _context2.sent;

              case 10:
                if (query.status == 200) {
                  Message.success(query.message);

                  _this2.$emit("refreshDataList");

                  _this2.resetForm("ruleForm");
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  })
};